<template>
  <div>
    <div class="product5">
      <div class="productBanner">
        <div class="module">
          <div class="h1">ZTMapIndoor</div>
          <div class="line"></div>
          <div class="h2">室内地图可视化平台</div>
          <div class="p">专业的室内地图和定位引擎提供室内地图定位导航综合解决方案</div>
        </div>
        <div class="img"></div>
      </div>
      <div class="overview">
        <div class="module">
          <div class="productTitle">
            概述
            <span>/Overview</span>
          </div>
          <div
            class="p"
          >臻图室内GIS地图平台是应用于室内场景的二三维矢量地图可视化渲染平台，该产品实现了室内地图数据管理维护、室内地图前端展示渲染、应用开发调用一体化的完整功能体系。该产品以好看、好用、流畅作为开发设计的原则和目标。</div>
        </div>
      </div>
      <div class="composition">
        <div class="module">
          <div class="productTitle">
            产品组成
            <span>/Composition</span>
          </div>
          <div class="middle">
            <div class="list">
              <div>
                <div class="lable">地图编辑后台</div>
                <div class="p">实现三维室内地图的在线编辑绘制，所见即所得的流程和效果。</div>
              </div>
              <div>
                <div class="lable">三维渲染引擎</div>
                <div class="p">实现基于WEBGL的三维地图前端实时渲染，跨平台可交互。</div>
              </div>
              <div>
                <div class="lable">应用开发SDK</div>
                <div class="p">一套面向应用的二次开发SDK包，轻松实现不同场景的应用开发。</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rendering">
        <div class="module">
          <div class="productTitle">
            效果图
            <span>/Rendering</span>
          </div>
          <div class="list">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
      <div class="application">
        <div class="module">
          <div class="productTitle">
            行业应用
            <span>/Application</span>
          </div>
          <div class="list">
            <div>
              <div class="left">
                智慧停车
                <div class="c">A</div>
              </div>
              <div class="right">
                <div class="p">结合室内定位技术，实现停车预定、停车导航、反向寻车等功能</div>
              </div>
            </div>
            <div>
              <div class="left">
                智慧停车
                <div class="c">B</div>
              </div>
              <div class="right">
                <div class="p">结合室内定位技术，实现停车预定、停车导航、反向寻车等功能</div>
              </div>
            </div>
            <div>
              <div class="left">
                智慧停车
                <div class="c">C</div>
              </div>
              <div class="right">
                <div class="p">结合室内定位技术，实现停车预定、停车导航、反向寻车等功能</div>
              </div>
            </div>
            <div>
              <div class="left">
                智慧停车
                <div class="c">D</div>
              </div>
              <div class="right">
                <div class="p">结合室内定位技术，实现停车预定、停车导航、反向寻车等功能</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-product5">
      <div class="product-title">
        <div class="title-content">
          <div class="title">ZTMapIndoor</div>
          <div class="line"></div>
          <div class="p">
            室内地图可视化平台
          </div>
          <div class="span">
            专业的室内地图和定位引擎提供室内地图定位导航综合解决方案
          </div>
        </div>
        <div class="img">
          <img src="../../assets/images/index/banner_img5.png" alt="">
        </div>
      </div>
      <div class="part">
        <div class="part-title">概述</div>
        <div class="en-title">OVERVIEW</div>
        <div class="overview-content">
          臻图室内GIS地图平台是应用于室内场景的二三维矢量地图可视化渲染平台，该产品实现了室内地图数据管理维护、室内地图前端展示渲染、应用开发调用一体化的完整功能体系。该产品以好看、好用、流畅作为开发设计的原则和目标。
        </div>
      </div>
      <div class="part function">
        <div class="part-title">产品组成</div>
        <div class="en-title">COMPOSITION</div>
        <div class="content">
          <div class="item" v-for="item in functionList" :key="item.id">
            <p>{{ item.title }}</p>
            <span>{{ item.content }}</span>
          </div>
        </div>
      </div>
      <div class="rendering">
        <div class="part-title">效果图</div>
        <div class="en-title">RENDERING</div>
        <div class="swiper">
          <el-carousel class="case-carousel" indicator-position="outside" height="23rem" >
            <el-carousel-item v-for=" index in 4" :key="index">
              <img :src="getImg(`product5-${index}.jpg`)" alt="Carousel Image" style="width: 100%; object-fit: contain;">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="part function" :style="backgroundStyle">
        <div class="part-title">行业应用</div>
        <div class="en-title">APPLICATION</div>
        <div class="content">
          <div class="item" v-for="item in application" :key="item.id">
            <p>{{ item.title }}</p>
            <span>{{ item.content }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "Product5",
  metaInfo: {
    title:
      "室内GIS地图平台_室内定位_ZTMapIndoor-上海臻图信息技术有限公司",
    meta: [
      {
        name: "keywords",
        content: "室内地图,室内GIS,室内定位,室内导航,跨楼层导航,室内地图绘制"
      },
      {
        name: "description",
        content:
          "ZTMapIndoor臻图室内GIS地图平台是应用于室内场景的二三维矢量地图可视化渲染平台,该产品实现了室内地图数据管理维护、室内地图前端展示渲染、应用开发调用一体化的完整功能体系。该产品以好看、好用、流畅作为开发设计的原则和目标。"
      }
    ]
  },
  data() {
    return {
      functionList: [
        {
          id: 1,
          title: '地图编辑后台',
          content: '实现三维室内地图的在线编辑绘制，所见即所得的流程和效果。'
        },
        {
          id: 2,
          title: '三维渲染引擎',
          content: '实现基于WEBGL的三维地图前端实时渲染，跨平台可交互。'
        },
        {
          id: 3,
          title: '应用开发SDK',
          content: '一套面向应用的二次开发SDK包，轻松实现不同场景的应用开发。'
        },
      ],
      application: [
        {
          id: 1,
          title: '智慧停车',
          content: '更高效、逼真地展示产品'
        },
        {
          id: 2,
          title: '智慧停车',
          content: '更高效、逼真地展示产品'
        },
        {
          id: 3,
          title: '智慧停车',
          content: '更高效、逼真地展示产品'
        },
        {
          id: 4,
          title: '智慧停车',
          content: '更高效、逼真地展示产品'
        },
      ],
    };
  },
  methods: {
    getImg(fileName) {
      return require(`@/assets/images/product/${fileName}`);
    }
  },
  mounted: function() {}
};
</script>

<style lang="less" scoped>
//scoped
.productBanner {
  .img {
    background-image: url("../../assets/images/index/banner_img5.png");
  }
}
.product5 {
  .composition {
    .productTitle {
      text-align: center;
      margin-top: 100px;
    }
    .content {
      .title {
        font-size: 38px;
        color: rgba(75, 75, 75, 1);
        text-align: center;
      }
      .p {
        font-size: 16px;
        color: rgba(124, 124, 124, 1);
        line-height: 30px;
        margin-top: 20px;
      }
    }
    .middle {
      background: url("../../assets/images/product/arrow.png") no-repeat center
        top / 100% auto;
      margin-top: 40px;
      padding-left: 15px;
      margin-bottom: 100px;
      .list {
        font-size: 0;
        padding-top: 51px;
        > div {
          display: inline-block;
          width: 250px;
          margin-left: 62px;
          &:nth-child(1) {
            .lable {
              background: #ffca08;
            }
          }
          &:nth-child(2) {
            .lable {
              background: #f8931d;
            }
          }
          &:nth-child(3) {
            .lable {
              background: #d7db27;
            }
          }
          .lable {
            font-size: 24px;
            color: rgba(255, 255, 255, 1);
            height: 50px;
            line-height: 50px;
            text-align: center;
          }
          .p {
            font-size: 20px;
            color: rgba(124, 124, 124, 1);
            line-height: 28px;
            margin-top: 47px;
          }
        }
      }
    }
  }
  .rendering {
    .productTitle {
      text-align: center;
      margin-bottom: 40px;
      margin-top: 100px;
    }
    .list {
      font-size: 0;
      margin-bottom: 130px;
      > div {
        display: inline-block;
        width: 584px;
        height: 383px;
        background: #ccc;
        margin-bottom: 20px;
        background: no-repeat center center / 100% 100%;
        &:nth-child(1) {
          background-image: url("../../assets/images/product/product5-1.jpg");
        }
        &:nth-child(2) {
          background-image: url("../../assets/images/product/product5-2.jpg");
        }
        &:nth-child(3) {
          background-image: url("../../assets/images/product/product5-3.jpg");
        }
        &:nth-child(4) {
          background-image: url("../../assets/images/product/product5-4.jpg");
        }
        &:nth-child(2n + 1) {
          margin-right: 20px;
        }
      }
    }
  }
  .application {
    .productTitle {
      text-align: center;
      margin-bottom: 39px;
    }
    .list {
      font-size: 0;
      > div {
        display: inline-block;
        width: 50%;
        height: 201px;
        margin-bottom: 31px;
        > .left {
          width: 194px;
          height: 201px;
          display: inline-block;
          box-sizing: border-box;
          vertical-align: top;
          padding: 15px 69px 0 102px;
          font-size: 24px;
          color: rgba(255, 255, 255, 1);
          line-height: 33px;
          position: relative;
          .c {
            font-size: 24px;
            position: absolute;
            bottom: 32px;
            left: 32px;
            line-height: 24px;
          }
        }
        > .right {
          font-size: 20px;
          width: 406px;
          color: rgba(124, 124, 124, 1);
          line-height: 36px;
          display: inline-block;
          box-sizing: border-box;
          padding: 45px 0 0 15px;
        }
        &:nth-child(1) {
          > .left {
            background: url("../../assets/images/product/application_bg5.png")
              no-repeat center center/100% 100%;
            .c {
              color: #70b4ff;
            }
          }
        }
        &:nth-child(2) {
          > .left {
            background: url("../../assets/images/product/application_bg6.png")
              no-repeat center center/100% 100%;
            .c {
              color: #f895a4;
            }
          }
        }
        &:nth-child(3) {
          > .left {
            background: url("../../assets/images/product/application_bg7.png")
              no-repeat center center/100% 100%;
            .c {
              color: #a8efa3;
            }
          }
        }
        &:nth-child(4) {
          > .left {
            background: url("../../assets/images/product/application_bg8.png")
              no-repeat center center/100% 100%;
            .c {
              color: #ffd28e;
            }
          }
        }
      }
    }
  }
}
.mobile-product5 {
  display: none;
  flex-direction: column;
  font-family: 'Normal';
  .product-title {
    width: 100%;
    height: 28rem;
    background: linear-gradient(180deg, #3374EF 0%, #9DCFFF 100%);
    box-sizing: border-box;
    padding: 8rem 0 0 2rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    color: white;
    .title-content {
      .title {
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
      }
      .line {
        width: 4rem;
        height: 0.2rem;
        background: #FFFFFF;
        margin-top: 1rem;
      }
      .p {
        font-size: 1.4rem;
        font-weight: 500;
        line-height: 2rem;
        margin-top: 2rem;
      }
      .span {
        width: 15rem;
        margin-top: 1rem;
        font-size: 1rem;
        font-weight: 350;
        line-height: 1.6rem;
      }
    }
    .img {
      flex-grow: 1;
      img {
        width: 100%;
        object-fit: contain;
      }
    }
  }
  .part {
    box-sizing: border-box;
    padding: 2rem;
    text-align: center;
    font-family: 'Normal';
    .part-title {
      font-size: 1.8rem;
      font-weight: bold;
      line-height: 3rem;
      color: #333;
    }
    .en-title {
      font-size: 1.4rem;
      font-weight: 350;
      line-height: 2rem;
      color: #999;
    }
  }
  .part {
    box-sizing: border-box;
    padding: 2rem;
    text-align: center;
    font-family: 'Normal';
    .overview-title {
      font-size: 1.8rem;
      font-weight: bold;
      line-height: 3rem;
      color: #333;
    }
    .en-title {
      font-size: 1.4rem;
      font-weight: 350;
      line-height: 2rem;
      color: #999;
    }
    .overview-content {
      font-size: 1rem;
      font-weight: 350;
      line-height: 2rem;
      color: #3D3D3D;
      text-align: left;
      text-indent: 2em;
      margin-top: 2rem;
      color: #333333;
    }
  }
  .function {
    background-image: url('../../assets/images/product/bg1.png');
    background-position: 0%;
    background-repeat: no-repeat;
    background-size: cover;
    .content {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      box-sizing: border-box;
      .item {
        width: 47.5%;
        box-sizing: border-box;
        padding: 2rem 1.5rem 1.5rem 1.5rem;
        background: rgba(255, 255, 255, 0.5);
        font-family: 'Normal';
        margin-top: 1.5rem;
        text-align: left;
        >p {
          font-size: 1.4rem;
          font-weight: bold;
          line-height: 2rem;
          text-align: center;
        }
        >span {
          font-size: 1rem;
          font-weight: 350;
          line-height: 1.5rem;
          margin-top: 2rem;
          color: #333333;
          
        }
      }
    }
  }
  .rendering {
    text-align: center;
    font-family: 'Normal';
    box-sizing: border-box;
    padding: 2rem 0;
    .part-title {
      font-size: 1.8rem;
      font-weight: bold;
      line-height: 3rem;
      color: #333;
    }
    .en-title {
      font-size: 1.4rem;
      font-weight: 350;
      line-height: 2rem;
      color: #999;
    }
    .swiper {
      margin-top: 2rem;
    }
  }
  .characteristics {
    background-image: url('../../assets/images/product/bg1.png');
    background-position: left;
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;
    font-family: 'Normal';
    box-sizing: border-box;
    padding: 2rem;
    height: 25rem;
    .part-title {
      font-size: 1.8rem;
      font-weight: bold;
      line-height: 3rem;
      color: #333;
    }
    .en-title {
      font-size: 1.4rem;
      font-weight: 350;
      line-height: 2rem;
      color: #999;
    }
    .content {
      width: 100%;
      box-sizing: border-box;
      padding-top: 2rem;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        box-sizing: border-box;
        padding: 0 0.5rem;
        margin-top: 1rem;
        div {
          width: 50%;
          display: flex;
          align-items: center;
          >p {
            font-size: 1.2rem;
            font-weight: bold;
            color: #999999;
          }
          >span {
            margin-left: 1rem;
            font-size: 1rem;
            font-weight: 350;
            color: #333333;
          }
        }
      }
    }
  }
}
/deep/.el-carousel__indicators--horizontal  {
  width:100% !important;
  text-align: center !important;
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
/deep/ .el-carousel__button {
  width: 0.5rem;
  height: 0.4rem;
  background: #C1E1FF;
}
/deep/ .case-carousel {
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
@media (max-width: 1024px) {
  .productBanner {
    display: none !important;
  }
  .product5 {
    display: none;
  }
  .mobile-product5 { 
    display: flex !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/product/Product5.vue